export default __webpack_public_path__ + "static/media/lamp.bdc89597.png";